import { createContext, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const CallCommentsContext = /*#__PURE__*/createContext({});
export const CallCommentsContextProvider = props => {
  const {
    children,
    commentsAutoScrollButtonClickCallback,
    timestampManualEntryCallback,
    timestampRefreshButtonClickCallback
  } = props;
  const [anchorCallTime, setAnchorCallTime] = useState(null);
  const [autoscrollComments, setAutoscrollComments] = useState(true);
  const contextValue = {
    anchorCallTime,
    setAnchorCallTime,
    autoscrollComments,
    setAutoscrollComments,
    commentsAutoScrollButtonClickCallback,
    timestampManualEntryCallback,
    timestampRefreshButtonClickCallback
  };
  return /*#__PURE__*/_jsx(CallCommentsContext.Provider, {
    value: contextValue,
    children: children
  });
};